import React from 'react';
import { Form, Modal, ButtonGroup } from 'react-bootstrap';
import { Button, Row, Col } from 'reactstrap';
import { Save2Fill, Backspace } from 'react-bootstrap-icons';
import 'jspdf-autotable';

import moment from 'moment';
import Axios from 'axios';
import * as Yup from 'yup';
import { Formik } from 'formik';
import dateformat from 'dateformat';
import common from '../../../commonData';

function FacturerModal({ show, setShowFactureModal, getFacture, datafacture, setMsg, setMsgravity, setIsSave, setLoad }) {
    window.moment = moment;
    const handleClose = () => {
        setShowFactureModal(false);
    };

    function saveFact(data) {
        if (window.confirm('Voulez-vous facturer cette ligne?')) {
            setLoad(true);
            // setIsLoad(true);

            var formData = new FormData();
            formData.append('date', data.date);
            formData.append('numbon', data.numbon);
            Axios({
                url: common.ipapi + '/api/facture/updatefact/' + datafacture[0],
                method: 'POST',
                headers: {
                    'Content-Type': 'form-data'
                },
                data: formData
            }).then((response) => {
                if (response.data.status === 1) {
                    setShowFactureModal(false);
                    setMsg(response.data.msg);
                    setMsgravity('info');
                    setIsSave(true);
                    setLoad(false);
                    getFacture();
                } else {
                    setMsg(response.data.msg);
                    setIsSave(true);
                    setMsgravity('danger');
                    setLoad(false);
                    // setIsLoad(false);
                }
            });
        }
    }
    return (
        <>
            <Row>
                <Col md="12">
                    <Formik
                        initialValues={{
                            numbon: null,
                            date: null,
                            submit: null
                        }}
                        // enableReinitialize
                        validationSchema={Yup.object().shape({
                            date: Yup.date().required(common.msg)
                        })}
                        onSubmit={async (values) => {
                            try {
                                saveFact(values);
                                // setSubmitting(false);
                            } catch (err) {
                                setMsg('Une erreur à eu lieu');
                                setMsgravity('danger');
                                setIsSave(true);
                                setLoad(false);
                            }
                        }}
                    >
                        {({ handleBlur, handleChange, handleSubmit, values, errors }) => (
                            <Modal show={show} onHide={handleClose}>
                                <Modal.Header>
                                    FACTURATION <Backspace onClick={handleClose} color="red" size={25} />
                                </Modal.Header>
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Modal.Body>
                                        <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                            <Form.Label column sm={4}>
                                                N° proforma:
                                            </Form.Label>
                                            <Col sm={8}>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="N° proforma"
                                                    aria-describedby="inputGroupPrepend"
                                                    size="sm"
                                                    value={datafacture[1]}
                                                    disabled
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                            <Form.Label column sm={4}>
                                                Date proforma:
                                            </Form.Label>
                                            <Col sm={8}>
                                                <Form.Control
                                                    type="date"
                                                    placeholder="Date proforma"
                                                    aria-describedby="inputGroupPrepend"
                                                    required
                                                    disabled
                                                    size="sm"
                                                    value={datafacture[2] ? dateformat(datafacture[2], 'yyyy-mm-dd') : ''}
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                            <Form.Label column sm={4}>
                                                N° facture:
                                            </Form.Label>
                                            <Col sm={8}>
                                                <Form.Control
                                                    id="numbon"
                                                    type="text"
                                                    placeholder="Numero facture"
                                                    aria-describedby="inputGroupPrepend"
                                                    size="sm"
                                                    value={values.numbon}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                            <Form.Label column sm={4}>
                                                Date édition:
                                            </Form.Label>
                                            <Col sm={8}>
                                                <Form.Control
                                                    id="date"
                                                    type="date"
                                                    placeholder="Date édition"
                                                    aria-describedby="inputGroupPrepend"
                                                    required
                                                    size="sm"
                                                    value={values.date}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                />
                                                {errors.date && <div id="feedback">{errors.date}</div>}
                                            </Col>
                                        </Form.Group>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <div className="ml-auto">
                                            <ButtonGroup size="sm">
                                                <Button color="secondary" onClick={handleClose}>
                                                    <Backspace color="red" size={20} />
                                                </Button>
                                                <Button type="submit" color="warning">
                                                    <Save2Fill color="#807f7e" size={20} /> Enregistrer
                                                </Button>
                                            </ButtonGroup>
                                        </div>
                                        {/* <Button type="submit" variant="success" ><Save color="white" size={20}/> Valider</Button> */}
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}
                    </Formik>
                </Col>
            </Row>
        </>
    );
}

export default FacturerModal;
